import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=062a6ed1&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=062a6ed1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a6ed1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('062a6ed1')) {
      api.createRecord('062a6ed1', component.options)
    } else {
      api.reload('062a6ed1', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=062a6ed1&scoped=true&", function () {
      api.rerender('062a6ed1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-24KTSa65vd27v/JS/comp/Paginate.vue"
export default component.exports